import {
  CREATE_CATEGORY,
  CREATE_CATEGORY_FAILED,
  CREATE_CATEGORY_SUCCESS,
  DELETE_CATEGORY,
  DELETE_CATEGORY_FAILED,
  DELETE_CATEGORY_SUCCESS,
  DISABLE_CATEGORY,
  DISABLE_CATEGORY_FAILED,
  DISABLE_CATEGORY_SUCCESS,
  GET_CATEGORIES,
  GET_CATEGORIES_FAILED,
  GET_CATEGORIES_SUCCESS,
  ON_SEARCH_CATEGORY,
  RESET_FORM_CATEGORY,
  UPDATE_CATEGORY,
  UPDATE_CATEGORY_FAILED,
  UPDATE_CATEGORY_SUCCESS,
} from './constants';

export const getCategories = () => ({
  type: GET_CATEGORIES,
});

export const getCategoriesSuccess = (categories) => ({
  type: GET_CATEGORIES_SUCCESS,
  payload: { categories },
});

export const getCategoriesFailed = (error) => ({
  type: GET_CATEGORIES_FAILED,
  payload: { error },
});

export const onCreateCategory = (category) => ({
  type: CREATE_CATEGORY,
  payload: { category },
});

export const onCreateCategorySuccess = (category) => ({
  type: CREATE_CATEGORY_SUCCESS,
  payload: { category },
});

export const onCreateCategoryFailed = (error) => ({
  type: CREATE_CATEGORY_FAILED,
  payload: { error },
});

export const onUpdateCategory = (category) => ({
  type: UPDATE_CATEGORY,
  payload: { category },
});

export const onUpdateCategorySuccess = (category) => ({
  type: UPDATE_CATEGORY_SUCCESS,
  payload: { category },
});

export const onUpdateCategoryFailed = (error) => ({
  type: UPDATE_CATEGORY_FAILED,
  payload: { error },
});

export const onDisableCategory = (categoryId, status) => ({
  type: DISABLE_CATEGORY,
  payload: { categoryId, status },
});

export const onDisableCategorySuccess = (category) => ({
  type: DISABLE_CATEGORY_SUCCESS,
  payload: { category },
});

export const onDisableCategoryFailed = (error) => ({
  type: DISABLE_CATEGORY_FAILED,
  payload: { error },
});

export const onDeleteCategory = (category) => ({
  type: DELETE_CATEGORY,
  payload: { category },
});

export const onDeleteCategorySuccess = (categoryId) => ({
  type: DELETE_CATEGORY_SUCCESS,
  payload: { categoryId },
});

export const onDeleteCategoryFailed = (error) => ({
  type: DELETE_CATEGORY_FAILED,
  payload: { error },
});
export const onResetCategoryForm = () => ({
  type: RESET_FORM_CATEGORY,
});

export const onSearchCategory = (text) => ({
  type: ON_SEARCH_CATEGORY,
  payload: { text },
});
